import React, { FormEvent, FC, MouseEvent } from "react";

import { toast } from "react-toastify";

import {
  useApisMembersPrivateQuestionAnswersCreate,
  useBoolean,
  useInput,
} from "~/hooks/";

import { PrivateQuestionAnswerType } from "~/domains";

import { Form, FormSubmitButton } from "~/ui";
import {
  LabelWithTextArea,
  TogglablePostHeader,
  LabelWithTextField,
} from "~/ui";

type PropsType = {
  className?: string;
  privateQuestionAnswer?: PrivateQuestionAnswerType;
  unshiftItem?: (privateQuestionAnswer: PrivateQuestionAnswerType) => void;
  disabled?: boolean;
};

export const PrivateQuestionAnswerForm: FC<PropsType> = ({
  className = "",
  privateQuestionAnswer,
  unshiftItem,
  disabled = false,
}: PropsType) => {
  const [{ value: question, onChange: onChangeQuestion }, setQuestion] =
    useInput(privateQuestionAnswer?.questionContent || "");
  const [{ value: answer, onChange: onChangeAnswer }, setAnswer] = useInput(
    privateQuestionAnswer?.answerContent || "",
  );
  const [{ value: link, onChange: onChangeLink }, setLink] = useInput(
    privateQuestionAnswer?.link || "",
  );

  const { isChecked: isToggleOpen, toggle } = useBoolean(false);

  const { mutate: postRequest, isLoading: isSubmitting } =
    useApisMembersPrivateQuestionAnswersCreate();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const body = {
      questionContent: question,
      answerContent: answer,
      link,
    };

    postRequest(
      {
        body,
      },
      {
        onSuccess: (data) => {
          unshiftItem?.(data.privateQuestionAnswer);
          toast(data.message);
          formReset();
        },
      },
    );
  };

  const formReset = () => {
    setQuestion("");
    setAnswer("");
    setLink("");
  };

  const handleSetToggle = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    toggle();
  };

  return (
    <Form className={`space-y-6 ${className}`} onSubmit={onSubmit}>
      {privateQuestionAnswer && (
        <TogglablePostHeader
          employeeName={privateQuestionAnswer.employee.name}
          createdAt={privateQuestionAnswer.createdAt}
          avatarUrl={privateQuestionAnswer.employee.avatarUrl}
          handleToggle={handleSetToggle}
          isOpen={isToggleOpen}
        />
      )}
      {(!privateQuestionAnswer || isToggleOpen) && (
        <>
          <LabelWithTextArea
            labelText="Q (質問)"
            name="question"
            placeholder="Q (質問)"
            required
            rows={1}
            value={question}
            onChange={onChangeQuestion}
            disabled={disabled}
          />
          <LabelWithTextArea
            labelText="A (答え)"
            name="answer"
            placeholder="A (答え)"
            required
            rows={8}
            value={answer}
            onChange={onChangeAnswer}
            disabled={disabled}
          />
          <LabelWithTextField
            type="url"
            labelText="参考リンク"
            name="link"
            placeholder="参考リンク"
            value={link}
            onChange={onChangeLink}
            disabled={disabled}
          />
          {privateQuestionAnswer && (
            <span className="text-secondary-600 text-xs">
              {privateQuestionAnswer.createdAt}
            </span>
          )}
          {!disabled && (
            <FormSubmitButton
              value="保存"
              color="primary"
              isReadOnly={isSubmitting}
              className="w-full"
            />
          )}
        </>
      )}
    </Form>
  );
};
